import React from 'react';
import {Linking, View} from 'react-native';
import BottomSheet from '../../Interface/LegacyBottomSheet';
import {Button} from '../../Interface/Forms/Buttons/Button';
import {Titles} from '../../Interface/Typographies/Titles';
import {
  Container,
  Header,
  Title,
  Description,
  SupportOption,
  SupportOptionIcon,
  SupportOptionContent,
  SupportOptionTitle,
  SupportOptionDescription,
  SupportOptionButton,
  SupportOptionButtonText,
} from './styles';
import {RFValue} from 'react-native-responsive-fontsize';

interface Props {
  isOpen: boolean;
  onClose: () => void;
}

export function SupportTypeBottomSheet({isOpen, onClose}: Props) {
  const handleSupportPress = (phoneNumber: string) => {
    const whatsappUrl = `https://api.whatsapp.com/send/?phone=${phoneNumber}&text&type=phone_number&app_absent=0`;
    Linking.openURL(whatsappUrl);
    onClose();
  };

  return (
    <BottomSheet isOpen={isOpen} onClose={onClose}>
      <Container>
        <Header>
          <Title>Escolha o tipo de atendimento</Title>
          <Description>
            Selecione a opção que melhor atende sua necessidade
          </Description>
        </Header>

        <SupportOption>
          <SupportOptionIcon name="bolt" />
          <SupportOptionContent>
            <SupportOptionDescription>
              Resposta rápida para dúvidas gerais
            </SupportOptionDescription>
          </SupportOptionContent>
        </SupportOption>
        <View style={{ marginTop: RFValue(8)}}>
          <Button
            enabled
            onPress={() => handleSupportPress('5561998202004')}
            title="Atendimento Rápido"
          />
        </View>

       
      </Container>
    </BottomSheet>
  );
}
